<div class="skeleton-container">
  <div class="skeleton-header">
    <div class="skeleton-header-item"></div>
    <div class="skeleton-header-item"></div>
  </div>
  <div class="skeleton-aside"></div>
  <div class="skeleton-body">
    <div class="skeleton-body-item"></div>
    <div class="skeleton-body-item"></div>
    <div class="skeleton-body-item"></div>
  </div>
  <div class="skeleton-icon"></div>
</div>
